import store from "../../erp_store/erp_store"
import router from "../../erp_router"

export default {
	errorResponse(e) {
		console.log(e)
		switch (e.response?.status) {
			case 400:
				if (Array.isArray(e.response.data)) {
					store.dispatch("setFlash", {
						type: "alert",
						text: "入力に誤りがあります",
					})			
					return e.response.data
				} else if (e.response.data.message) {
					var message = e.response.data.message
				}
				break
			case 401:
				if (e.response.data?.success == false) {
					var message = e.response.data.errors[0]
				} else if (e.response.data.message) {
					store.dispatch("auth/logOut")
					var message = e.response.data.message
					router.push({ name: "erp_login" })
				} else {
					store.dispatch("auth/logOut")
					var message = "ログインして下さい"
					router.push({ name: "erp_login" })
				}
				break
			case 403:
				if (Array.isArray(e.response.data)) {
					return e.response.data
				} else if (e.response.data.message) {
					var message = e.response.data.message
				}
				break
			case 404:
				var message = "ページが見つかりませんでした"
				// 開発用にコメントアウト
				// router.push("/")
				break
			case 405:
				var message = "許可されていないリクエストです"
				break
			case 408:
				var message = "リクエストに時間がかかりすぎているため、切断されました"
				break
			case 413:
				var message = "ファイルサイズが大きすぎます"
				break
			case 415:
				var message = "サーバーが対応していないフォーマットのファイルです"
				break
			case 422:
				if (e.response?.data) {
					var message = e.response.data.message
					if (e.response.data.type == "redirect") {
						var route = e.response.data.route
						router.push(route)
					}
				} else {
					var message = "入力に誤りがあります"
				}
				break
			case 429:
				var message = "短時間に大量にリクエストが発生しています"
				break
			case 500:
				var message = "サーバーで問題が発生しました"
				break
			case 502:
				var message = "サーバーで問題が発生しました"
				break
			case 503:
				var message = "サーバーへのアクセスが集中しているため、アクセスできませんでした"
				break
			case 504:
				var message = "サーバーからの応答時間が長すぎるため、切断されました"
				break
			default:
		}
		if (!message) {
			var message = "エラーが発生しました"
		}
		store.dispatch("setFlash", {
			type: "alert",
			text: message,
		})
	},
}
